import React, { useEffect, useState } from "react";
import {
 fetchVocabularyList,
 deleteVocabulary,
 bulkDeleteVocabulary,
} from "./adminVocabularyService";
import AdminVocabularyForm from "./AdminVocabularyForm";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicImgSrc = (url) => {
  if (!url) return "";
  const pub = url.replace(/\/api\/admin\/media-images\//, "/api/public/media-images/");
  console.log("[VocabularyPage] imageUrl raw:", url, "→ resolved:", `${BASE_ROOT}${pub}`);
  return `${BASE_ROOT}${pub}`;
};

const AdminVocabularyPage = () => {
 const [data, setData] = useState([]);
 const [loading, setLoading] = useState(false);

 const [search, setSearch] = useState("");
 const [selectedIds, setSelectedIds] = useState([]);

 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);

 // ✅ Form states
 const [showForm, setShowForm] = useState(false);
 const [editing, setEditing] = useState(null);

 // ✅ Only log in development

 // Helper function to capitalize part of speech
 const capitalizePartOfSpeech = (pos) => {
 if (!pos) return pos;
 return pos.charAt(0).toUpperCase() + pos.slice(1).toLowerCase();
 };

 useEffect(() => {
 loadData();
 }, [page, search]);

 const loadData = async () => {
 setLoading(true);

 try {
 const res = await fetchVocabularyList({
 page,
 size: 20,
 search,
 });

 if (res.status === 200 && res.data) {
 setData(res.data.content || []);
 setTotalPages(res.data.totalPages || 0);
 } else {
 setData([]);
 alert(res.message || "Failed to load data");
 }
 } catch (error) {
 setData([]);
 alert("Something went wrong while loading data");
 }

 setLoading(false);
 };

 // =========================
 // CREATE / EDIT HANDLERS
 // =========================

 const handleCreate = () => {
 setEditing(null);
 setShowForm(true);
 };

 const handleEdit = (item) => {
 setEditing(item);
 setShowForm(true);
 };

 const onFormSaved = () => {
 setShowForm(false);
 setEditing(null);
 loadData();
 };

 // =========================
 // DELETE
 // =========================

 const handleDelete = async (id) => {
 if (!window.confirm("Delete this word?")) return;

 const res = await deleteVocabulary(id);

 if (res.status === 200 || res.status === 204) {
 loadData();
 } else {
 alert(res.message);
 }
 };

 const handleBulkDelete = async () => {
 if (selectedIds.length === 0) return;

 if (!window.confirm("Delete selected words?")) return;

 const res = await bulkDeleteVocabulary(selectedIds);

 if (res.status === 200) {
 setSelectedIds([]);
 loadData();
 } else {
 alert(res.message);
 }
 };

 // =========================
 // CHECKBOX
 // =========================

 const toggleSelect = (id) => {
 setSelectedIds((prev) =>
 prev.includes(id)
 ? prev.filter((x) => x !== id)
 : [...prev, id]
 );
 };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>Vocabulary Management</h2>

 <button onClick={handleCreate}>
 + Add Vocabulary
 </button>
 </div>

 {showForm && (
 <AdminVocabularyForm
 vocabulary={editing}
 onSaved={onFormSaved}
 onCancel={() => setShowForm(false)}
 />
 )}

 {/* SEARCH */}
 <input
 type="text"
 placeholder="Search word or definition..."
 value={search}
 onChange={(e) => {
 setPage(0); // reset page on search
 setSearch(e.target.value);
 }}
 />

 {/* BULK DELETE */}
 {selectedIds.length > 0 && (
 <button onClick={handleBulkDelete}>
 Delete Selected ({selectedIds.length})
 </button>
 )}

 {/* TABLE */}
 {loading ? (
 <p>Loading...</p>
 ) : (
 <table className="announcement-table">
 <thead>
 <tr>
 <th></th>
 <th>Image</th>
 <th>Word</th>
 <th>Definition</th>
 <th>Difficulty</th>
 <th>Part of Speech</th>
 <th>Etymology</th>
 <th>Actions</th>
 </tr>
 </thead>

 <tbody>
 {data.length === 0 ? (
 <tr>
 <td colSpan="7">No vocabulary found</td>
 </tr>
 ) : (
 data.map((item) => (
 <tr key={item.id}>
 <td>
 <input
 type="checkbox"
 checked={selectedIds.includes(item.id)}
 onChange={() => toggleSelect(item.id)}
 />
 </td>
 <td>
 {item.imageUrl ? (
 <img
 src={toPublicImgSrc(item.imageUrl)}
 alt={item.word}
 style={{ width: 44, height: 44, objectFit: "contain", background: "#f5f5f5", borderRadius: 6, border: "1px solid #eee" }}
 />
 ) : (
 <div style={{ width: 44, height: 44, background: "#f5f5f5", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#bbb" }}>—</div>
 )}
 </td>
 <td>{item.word}</td>
 <td>{item.definition}</td>
 <td>{item.difficulty}</td>
 <td>
 {Array.isArray(item.partOfSpeech) 
 ? item.partOfSpeech.map((pos, index) => (
 <span 
 key={index}
 style={{
 display: 'inline-block',
 background: '#e3f2fd',
 color: '#1976d2',
 padding: '2px 6px',
 borderRadius: '8px',
 fontSize: '11px',
 marginRight: '4px',
 marginBottom: '2px'
 }}
 >
 {capitalizePartOfSpeech(pos)}
 </span>
 ))
 : item.partOfSpeech ? capitalizePartOfSpeech(item.partOfSpeech) : '—'
 }
 </td>
 <td style={{ fontSize: 12, color: "#666", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.etymology || "—"}</td>

 <td>
 <button onClick={() => handleEdit(item)}>
 Edit
 </button>

 <button
 className="delete-btn"
 onClick={() => handleDelete(item.id)}
 >
 Delete
 </button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 {/* PAGINATION */}
 <div style={{ marginTop: "20px" }}>
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>
 Prev
 </button>

 <span style={{ margin: "0 10px" }}>
 Page {page + 1} / {totalPages || 1}
 </span>

 <button
 disabled={page + 1 >= totalPages}
 onClick={() => setPage(page + 1)}
 >
 Next
 </button>
 </div>
 </div>
 );
};

export default AdminVocabularyPage;